<div class="about-section">
    <div class="container">
        <div class="row align-items-center m-1">
            <!-- Left Side: Text -->
            <div class="col-md-7 col-12 about-text">
                <h2>The Music Program</h2>
                <!-- <h3>Diverse Avenues for Discovery and Growth</h3> -->
                <p>
                    The Music Program at Innovative Vision is designed to be a vibrant and joyful
                    exploration of sound, rhythm, and creative expression. We believe that music is
                    a universal language that stimulates a child's auditory senses and cognitive development,
                    and our program is crafted to foster a lifelong love for it. It's a key component of our
                    holistic approach, nurturing the mind, body, and soul.
                </p>
            </div>
            <!-- Right Side: Image -->
            <div class="col-md-5 col-12 text-center about-img">
                <img src="assets/ivimg/programDetails/musicH.svg" alt="Girl Learning Pottery" class="img-fluid">
            </div>
        </div>
    </div>
</div>
<div class="key-focus-section m-3">
    <div class="image-container">
        <img src="assets/ivimg//programDetails/musicF.svg" alt="Key Focus Areas"/>
    </div>
    <div class="content">
        <h2 class="section-title">Key Focus Areas</h2>
        <div class="points">
            <p>
                <strong>1. Auditory & Cognitive Development:</strong> Engaging with melodies and rhythms helps children
                develop better listening skills, memory, and concentration. Our curriculum introduces children to
                different musical concepts in a fun and interactive way, which significantly benefits their cognitive
                development.
            </p>
            <p>
                <strong>2. Creative Expression & Imagination:</strong> Music provides a powerful outlet for creativity.
                Whether through singing, playing an instrument, or creating their own compositions, children learn to
                express their feelings and ideas, which nurtures their imagination and emotional intelligence.
            </p>
            <p>
                <strong>3. Body & Rhythm Coordination:</strong> Our program incorporates rhythmic movements and
                activities that help children develop their gross motor skills and a better sense of body-rhythm
                coordination. This is an essential component for both musical and physical development.
            </p>
        </div>
    </div>
</div>


<div class="program-highlights">
    <div class="highlight-container">
        <!-- Image from assets -->
        <div class="image-container">
            <img src="assets/ivimg/PD-2.svg" alt="Program Highlights" />
        </div>

        <!-- Text Content -->
        <div class="text-container">

            <h2 class="title">Program Highlights</h2>
            <p>
                <strong>Play-Based Learning:</strong> We use games, songs, and imaginative scenarios to make learning
                music an exciting and engaging experience. This ensures children stay enthusiastic about the program and
                develop a positive association with music.
            </p>
            <p>
                <strong>Diverse Musical Exposure:</strong> Children are introduced to a variety of musical genres and
                instruments, from classical to contemporary, and from string instruments to percussion. This broad
                exposure helps them discover their own preferences and talents.
            </p>
            <p>
                <strong>Right-Brain Stimulation:</strong> The creative and intuitive nature of music is a powerful
                stimulus for the right side of the brain. This is crucial for non-linear thinking, spatial awareness,
                and emotional intelligence, which are vital for a well-rounded individual.
            </p>
        </div>
    </div>
</div>


<div class="benefits-section">
    <h2 class="benefits-title">Benefits for Your Child</h2>
    <p class="benefits-text">
        Our music program offers a multitude of benefits that go far beyond just learning an instrument. It enhances a
        child's memory and listening skills, boosts their creativity and emotional expression, and improves their
        coordination and social skills. It also provides a calming and joyful outlet, contributing to their emotional
        well-being. This program is a journey of self-discovery through sound, helping your child find their own unique
        rhythm in life.
    </p>
</div>